import gql from 'graphql-tag';

export const tagFragment = gql`
  fragment tagFragment on Tag {
    title
    status
    id
  }
`;

export const editorBlockDocumentListUserFragment = gql`
  fragment editorBlockDocumentListUserFragment on User {
    id
    fullName
    thumbUrl
    title
    email
  }
`;

export const editorBlockDocumentListRecipientFragment = gql`
  fragment editorBlockDocumentListRecipientFragment on Recipient {
    id
    companyName
    fullName
    thumbUrl
    title
    email
    contactId
    status
    role
    orderNum
    verifyQnaOpen
    verifySmsOpen
  }
`;

export const editorBlockDocumentListFragment = gql`
  fragment editorBlockDocumentListFragment on DocumentDto {
    id
    name
    companyName
    status
    value
    tags {
      ...tagFragment
    }
    user {
      ...editorBlockDocumentListUserFragment
    }
    recipients {
      ...editorBlockDocumentListRecipientFragment
    }
    type
    signDate
    isSigning
    sendDate
    createdAt
    isPrivate
    expirationDate
  }
  ${tagFragment}
  ${editorBlockDocumentListUserFragment}
  ${editorBlockDocumentListRecipientFragment}
`;

export const editorBlockDocumentFragment = gql`
  fragment editorBlockDocumentFragment on Document {
    id
    name
    status
    isSigning
    isSigningOrder
    isSelfsign
    type
    previewUrl
    expirationDate
    user {
      ...editorBlockDocumentListUserFragment
    }
    recipients {
      ...editorBlockDocumentListRecipientFragment
    }
  }
  ${editorBlockDocumentListUserFragment}
  ${editorBlockDocumentListRecipientFragment}
`;

export const suggestedContractFragment = gql`
  fragment suggestedContractFragment on SuggestedContracts {
    id
    name
    status
    isSigning
    isSigningOrder
    isSelfsign
    type
    previewUrl
    user {
      ...editorBlockDocumentListUserFragment
    }
    recipients {
      ...editorBlockDocumentListRecipientFragment
    }
  }
  ${editorBlockDocumentListUserFragment}
  ${editorBlockDocumentListRecipientFragment}
`;

export const productListFragment = gql`
  fragment productListFragment on Product {
    id
    sku
    name
    price
    tax
    description
    metaData {
      locale
      currency
    }
    updatedByFullName
    updatedAt
    createdByFullName
    createdAt
  }
`;
